import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { relocateWidget } from "../../api";
import { relocateZoneWidget } from "../../redux";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiMove, FiCheck, FiArrowLeft, FiHome } from "react-icons/fi";

const MoveWidgetComp = (props) => {
  const { t } = useTranslation();
  const { zone, toggleMove } = props;
  const dispatch = useDispatch();
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [zoneIndex, setZoneIndex] = useState();
  const [zoneId, setZoneId] = useState();
  const token = Cookies.get("token");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const zoneClicked = (value, index) => {
    setZoneIndex(index);
    setZoneId(value.id);
  };

  const relocateWidgetClicked = () => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("zone", zoneId);
    relocateWidget(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("ویجت با موفقیت منتقل شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
          toggleMove();
          dispatch(relocateZoneWidget(zone));
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("انتقال ویجت")}</h2>

      {/* Widget Info */}
      <div className="move-widget-info">
        <div className="move-widget-icon">
          <FiMove size={28} />
        </div>
        <div>
          <p className="move-widget-caption">{zone.caption}</p>
          <p className="move-widget-label">{t("انتقال به اتاق دیگر")}</p>
        </div>
      </div>

      {/* Zones List */}
      <div className="tickets-section">
        <h3 className="tickets-title">
          {/* <FiHome size={18} /> */}
          <span>{t("اتاق‌های موجود")}</span>
        </h3>
        
        <div className="zones-list">
          {dashboardZones?.map((zoneItem, index) => {
            const isActive = zoneIndex === index;
            return (
              <div
                className={`zone-item ${isActive ? "active" : ""}`}
                key={index}
                onClick={() => zoneClicked(zoneItem, index)}
              >
                <div className="zone-info">
                  <div className="zone-icon">
                    <FiHome size={16} />
                  </div>
                  <div>
                    <p className="zone-caption">{zoneItem.zone_caption}</p>
                  </div>
                </div>
                {isActive && (
                  <div className="zone-check">
                    <FiCheck size={16} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={toggleMove}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FiArrowLeft size={18} />
          <span>{t("انصراف")}</span>
        </button>
        <button 
          type="button" 
          className="setting-back-btn" 
          onClick={relocateWidgetClicked}
          disabled={!zoneId}
          style={{ 
            opacity: !zoneId ? 0.5 : 1,
            cursor: !zoneId ? "not-allowed" : "pointer"
          }}
        >
          <FiCheck size={18} />
          <span>{t("انتقال")}</span>
        </button>
      </div>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const MoveWidget = withRouter(MoveWidgetComp);

export { MoveWidget };